import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import ExhMap from './components/exhMap';
import { Provider } from 'react-redux';
import { Router, Switch, Route } from 'react-router-dom';
import store from './exhStore';
import history from './components/history';
import { Consent } from './components/consent';

const Home = () => <ExhMap />;

const wrapper = document.createElement('div');
wrapper.className = 'map-container';

const cookies = Object.fromEntries(
  document.cookie.split('; ').map(c => c.split('='))
);

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <Switch>
          {cookies['consent'] === '1' ? (
            <Route path={`/${I18n.locale}`}>
              <Home />
            </Route>
          ) : (
            <Route path={`/${I18n.locale}`}>
              <Consent />
            </Route>
          )}
        </Switch>
      </Router>
    </Provider>,
    document.body.appendChild(wrapper)
  );
});
